import { useParams, Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const ArtistIdRedirect = () => {
  const { id } = useParams<{ id: string }>();

  const { data: artist, isLoading } = useQuery({
    queryKey: ["artist-redirect", id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("bands")
        .select("slug")
        .eq("id", id!)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (artist?.slug) {
    return <Navigate to={`/artists/${artist.slug}`} replace />;
  }

  return <Navigate to="/artists" replace />;
};

export default ArtistIdRedirect;
